/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';
import { Observable } from 'rxjs';

export class MaintenanceApi extends BaseApi {
  endPoint: string = '/api/admin/maintenance';

  public flushCache(): Observable<any> {
    const _routeParams: any = {};
    return this.get(this.endPoint + '/cache/flush', _routeParams);
  }

  public recreateDBViews(): Observable<any> {
    const _routeParams: any = {};
    return this.get(this.endPoint + '/db-views/recreate', _routeParams);
  }
}
